// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/deployer/v1/endpoint_service.proto (package ai.h2o.deploy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { FieldMask, proto3 } from "@bufbuild/protobuf";
import { ConfigurableEndpoint } from "./endpoint_pb.js";

/**
 * The request message for creating an endpoint.
 *
 * @generated from message ai.h2o.deploy.CreateEndpointRequest
 */
export const CreateEndpointRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.CreateEndpointRequest",
  () => [
    { no: 1, name: "parent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "endpoint", kind: "message", T: ConfigurableEndpoint },
  ],
);

/**
 * The response message for creating an endpoint.
 *
 * @generated from message ai.h2o.deploy.CreateEndpointResponse
 */
export const CreateEndpointResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.CreateEndpointResponse",
  () => [
    { no: 1, name: "endpoint", kind: "message", T: ConfigurableEndpoint },
  ],
);

/**
 * The request message for getting an endpoint.
 *
 * @generated from message ai.h2o.deploy.GetEndpointRequest
 */
export const GetEndpointRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.GetEndpointRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * The response message for getting an endpoint.
 *
 * @generated from message ai.h2o.deploy.GetEndpointResponse
 */
export const GetEndpointResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.GetEndpointResponse",
  () => [
    { no: 1, name: "endpoint", kind: "message", T: ConfigurableEndpoint },
  ],
);

/**
 * The request message for listing endpoints.
 *
 * @generated from message ai.h2o.deploy.ListEndpointsRequest
 */
export const ListEndpointsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.ListEndpointsRequest",
  () => [
    { no: 1, name: "parent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * The response message for listing endpoints.
 *
 * @generated from message ai.h2o.deploy.ListEndpointsResponse
 */
export const ListEndpointsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.ListEndpointsResponse",
  () => [
    { no: 1, name: "endpoints", kind: "message", T: ConfigurableEndpoint, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * The request message for updating an endpoint.
 *
 * @generated from message ai.h2o.deploy.UpdateEndpointRequest
 */
export const UpdateEndpointRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.UpdateEndpointRequest",
  () => [
    { no: 1, name: "endpoint", kind: "message", T: ConfigurableEndpoint },
    { no: 2, name: "update_mask", kind: "message", T: FieldMask },
  ],
);

/**
 * The response message for updating an endpoint.
 *
 * @generated from message ai.h2o.deploy.UpdateEndpointResponse
 */
export const UpdateEndpointResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.UpdateEndpointResponse",
  () => [
    { no: 1, name: "endpoint", kind: "message", T: ConfigurableEndpoint },
  ],
);

/**
 * The request message for deleting an endpoint.
 *
 * @generated from message ai.h2o.deploy.DeleteEndpointRequest
 */
export const DeleteEndpointRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.DeleteEndpointRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * The response message for deleting an endpoint.
 *
 * @generated from message ai.h2o.deploy.DeleteEndpointResponse
 */
export const DeleteEndpointResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.DeleteEndpointResponse",
  [],
);

